export default "__VITE_ASSET__BHP4w_SQ__"